import { Dayjs } from "dayjs";

export class TransactionValueDto {
    id?: number;
    transactionDetailId?: number;
    transactionNumber?: string;
    date?: Dayjs | string;
    value?: number;
    isActive?: boolean;
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date;
    updatedBy?: string;

    constructor(value?: number, date?: Dayjs | string) {
        this.value = value;
        this.date = date;
        this.isActive = true;
    }
}
